import ApiEndpointConstants, {
  LIST_URL,
} from "../constans/ApiEndpointConstants";
import api from "./API";

export const getDetails = (id) => {
  return api.get(`${LIST_URL}${ApiEndpointConstants.GETDONTIONDETAIL}`, {
    params: { id },
  });
};
